<template>
    <container-page>
        <template v-slot:header>
            <span class="titlePage"> {{'Dashboard' | translate('Dashboard')}} </span>
        </template>
    </container-page>
</template>

<script>
import ContainerPage from '../../../src/components/containerPage.vue'

export default {
    name: 'Dashboard',
    components: {ContainerPage},
    data() {
        return {
        }
    },
    computed: {
    },
    methods: {
    }

}
</script>
<style scoped>
.titlePage{
    font-size: 20px;
    font-weight: 700;
}
</style>
